import { SESSION_STORAGE_KEYS } from '../constants';

const getPendingLineItemCreatedKey = (campaignId: string): string =>
  `${SESSION_STORAGE_KEYS.PENDING_LINE_ITEM_CREATED}:${campaignId}`;

export const markPendingLineItemCreatedForCampaign = (campaignId: string): void => {
  sessionStorage.setItem(getPendingLineItemCreatedKey(campaignId), 'true');
};

export const consumePendingLineItemCreated = (campaignId: string): boolean => {
  const key = getPendingLineItemCreatedKey(campaignId);
  const isPending = sessionStorage.getItem(key) === 'true';

  if (isPending) {
    sessionStorage.removeItem(key);
  }

  return isPending;
};
